const ptBr = {
  time_zone: 'Fuso Horário',
  chart: 'Gráfico',

  //Timeframes every
  every: 'A Cada',
  granularity: 'Granularidade',
  second: 'segundo',
  seconds: 'segundos',
  seconds_short: 's',
  minute: 'minuto',
  minutes: 'minutos',
  minute_short: 'm',
  hour: 'hora',
  hours: 'horas',
  hour_short: 'h',
  day: 'dia',
  days: 'dias',
  no_auto_refresh_short: 'Nenhum',

  // chrono units
  nanos: 'Nanos',
  micros: 'Micros',
  millis: 'Millis',
  half_days: 'Meio dias',
  weeks: 'Semanas',
  months: 'Meses',
  years: 'Anos',
  decades: 'Décadas',
  centuries: 'Séculos',
  millennia: 'Milênios',
  eras: 'Eras',
  forever: 'Para sempre',

  //Status
  on: 'Ligado',
  off: 'Desligado',
  auto: 'Automático',

  //common
  sensor_index: 'Índice do sensor',
  slave_device_number: 'Número do dispositivo escravo',
  select: 'Selecionar',
  create: 'Criar',
  update: 'Atualizar',
  relay_index: 'Índice do relé',
  devices: 'Dispositivos',
  device_name: 'Nome do dispositivo',
  device_number: 'Número do dispositivo',

  //command status
  pending: 'Pendente',
  sent: 'Enviado',
  cancelled: 'Cancelado',
  status_ok: 'Ok',
  status_nok: 'Não Ok',
  timeout: 'Tempo esgotado',
  unknown: 'Desconhecido',

  //Text
  text_add: 'Criar',
  text_edit: 'Editar',
  no_data_for_selected_period: 'Não há dados para o período selecionado',
  choose_location: 'Escolha a Localização',
  more_information: 'Mais Informações',
  track_device: 'Rastrear Dispositivo',
  not_found: 'Não Encontrado',
  powered_by: 'Distribuido por ',

  // Solution types
  solution_none: 'Não atribuído',
  solution_agri: 'Agricultura',
  solution_air_quality: 'Qualidade de ar',
  solution_street_lights: 'Iluminação pública',
  solution_pump_station: 'Estação de bombeamento',
  solution_smart_waste: 'Resíduos Inteligentes',
  solution_level: 'Monitoramento de nível',
  solution_gas: 'Monitoramento de gás',
  solution_pressure: 'Monitoramento de pressão',
  solution_smart_water: 'Água Inteligente',
  solution_energy: 'Monitoramento de energia',
  solution_environment_monitoring: 'Monitoramento do meio ambiente',

  //Control buttons
  add_button: 'Criar',
  edit_button: 'Editar',
  save_button: 'Salvar',
  cancel_button: 'Cancelar',
  clear_button: 'Limpar',
  language_button: 'Idioma',
  logout_button: 'Sair',
  change_info_for_field: 'Alterar informações dos campos',
  on_button: 'Liga',
  off_button: 'Desliga',
  auto_button: 'Auto',
  toggle_button: 'Alternar',
  door_open_sensor_text: 'Aberto',
  door_closed_sensor_text: 'Fechado',
  no_auto_refresh: 'Sem atualização automática',
  refresh_now: 'Atualizar agora',

  //Drawer form fields
  drawer_field_information_text: 'Informações do Campo',
  drawer_devices_config: 'Configuração dos dispositivos',
  drawer_layer_name: 'Nome da camada',
  drawer_status: 'Status',
  drawer_region_name: 'Nome da Região',
  drawer_description: 'Descrição',
  drawer_layer_size: 'Tamanho da Camada',
  drawer_previous_culture: 'Proxima Cultura',
  drawer_device: 'Dispositivo',
  drawer_sensor: 'Sensor',

  //Menu
  menu_home: 'Principal',
  menu_calendar: 'Calendario',
  menu_journal: 'Jornal',
  menu_alarms: 'Eventos',
  menu_streetlight: 'Iluminação Publica',
  menu_old_home: 'Principal (Antigo)',
  menu_trashbags: 'Sacos de Resíduos',
  menu_collections: 'Coletas',
  menu_truck_collections: 'Coletas por Caminhão',
  menu_truck_collections_by_container: 'Coletas por Caminhão por Contêiner',
  menu_container_collections: 'Coletas por Contêiner',
  menu_reports: 'Relatórios',

  //Map banner text
  map_banner_select: 'Selecione um campo',
  map_banner_create: 'Cria um campo',
  map_cluster_devices_header: 'Dispositivos ({{deviceCount}})',

  //Field information widget
  field_info_view: 'Visualiza',
  field_info_events: 'Eventos',
  field_info_header: 'Informações do campo',
  field_info_status: 'STATUS',
  field_info_region: 'REGIÃO',
  field_info_description: 'Descrição',
  field_info_area: 'AREA',
  field_info_previous_culture: 'CULTURA ANTERIOR',
  field_info_linked_devices: 'Dispositivos Vinculados',
  field_info_distance_traveled: 'Distância Percorrida',

  //Forecast widget
  forecast_today: 'Hoje',
  forecast_three_days: '3 dias',
  forecast_five_days: '5 dias',
  forecast_seven_days: '7 dias',
  forecast_min_temp: 'TEMP. MIN.',
  forecast_max_temp: 'TEMP. MAX.',
  forecast_cloud_cover: 'NUBLADO',
  forecast_rain: 'CHUVA',
  forecast_wind: 'VENTO',
  forecast_wind_direction: 'DIREÇÃO DO VENTO',
  forecast_humidity: 'HUMIDADE',

  //Rain Widget
  rain_widget_header: 'Chuva',

  //Humidity Widget
  humidity_widget_text: 'Humidade',

  //Soil Moisture Widget
  soil_moisture_widget_text: 'Humidade do Solo',

  //Control Widget
  control_widget_header: 'Controle',
  relay_control_get_relay_statuses: 'Obter status dos relés',
  poll_linked_devices: 'Consultar dispositivos vinculados',

  //Sensor information widget
  sensor_reference_values_label: 'Valores de Referência',
  sensor_board_label: 'QUADRO ELETRICO',
  sensor_all_info_header: 'Sensor',
  sensor_info_header: 'Informação do Sensor',
  sensor_info_name: 'Nome',
  sensor_info_device: 'Dispositivo',
  sensor_info_type: 'Tipe',
  sensor_info_status: 'Status',
  sensor_info_max: 'Max.',
  sensor_info_min: 'Min.',
  sensor_info_avg: 'Media',
  sensor_info_current: 'Atual',
  sensor_info_counters: 'Contador',
  sensor_info_start_button: 'INICIA',
  sensor_info_stop_button: 'PARA',
  sensor_last_refresh: 'Atualizado: {{time}}',
  sensor_info_board: 'GUADRO',
  sensor_info_manufacturer: 'Fabricante',
  sensor_info_model: 'Modelo',
  sensor_info_serial_number: 'Número de Série',
  sensor_info_diameter: 'Diâmetro',

  //Street lights information widget
  power_usage: 'CONSUMO DE ELETRICIDADE',
  lighting: 'ILUMINAÇÃO',
  lights_on: 'Liga',
  lights_off: 'Desliga',
  door_open: 'Aberta',
  door_closed: 'Fechada',

  //Pump station information
  pump1: 'Bomba 1',
  pump2: 'Bomba 2',

  //Device Information
  device_information_name: 'Nome',
  device_information_number: 'Número',
  device_information_model: 'Modelo',
  device_information_latitude: 'Latitude',
  device_information_longitude: 'Longitude',

  //Widget detailed button
  widget_detailed_button: 'Detalhado',

  //Back To Map Button
  back_to_map_btn: 'Voltar ao Mapa',

  //Wind widget
  wind_widget_header: 'Vento',

  //Dashboard
  boiler_condition_information: 'Informação de operação do reservatorio',
  street_light_information: 'Informação de Iluminação publica',
  pump_station_information: 'Informação da estação de Bomba',
  default_information_panel: 'Informação do Dispositivo',
  dashboard_header: 'Painel de controle por Campo:',
  dashboard_chart_value: 'valor',
  select_sensor_message: 'Selecione um sensor',

  //OnOffAutoLoader
  await_command_execution: 'Aguarde a execução do comando',
  command_successful: 'Comando executado com sucesso',
  command_unsuccessful: 'Erro ao executar o comando',
  command_error: 'Comando não executado',
  loading: 'Carregando',

  //Alarms
  alarms_page_header: 'Eventos',
  alarms_page_device_header: 'Eventos para o dispositivo {{deviceNumber}}',

  alarms_table_date_header: 'Data',
  alarms_table_device_number_header: 'Número do Dispositivo',
  alarms_table_type_header: 'Tipo',
  alarms_table_description_header: 'Descrição',
  alarms_table_sensor_name: 'Nome do Sensor',

  alarms_none_message: 'Nenhum evento no período selecionado',
  alarms_control_panel_select_date_message: 'Selecione a Data',
  alarms_control_panel_from_date: 'Data Início',
  alarms_control_panel_to_date: 'Data Fim',
  alarms_control_panel_alarm_type: 'Tipo de Evento',
  alarms_control_panel_alarm_status: 'Status do Evento',
  alarms_control_panel_by_device_number: 'Pesquisar por numero de dispositivo',
  alarms_control_panel_header: 'Filtro dos Eventos',

  // Value ranges
  value_ranges_light_rain: 'Chuva Fraca',
  value_ranges_moderate_rain: 'Chuva Moderada',
  value_ranges_heavy_rain: 'Chuva Forte',
  value_ranges_violent_rain: 'Chuva violenta',
  value_ranges_calm_wind: 'Vento Fraco',
  value_ranges_light_air: 'Ar Leve',
  value_ranges_light_breeze: 'Brisa Leve',
  value_ranges_gentle_breeze: 'Brisa suave',
  value_ranges_moderate_breeze: 'Brisa moderada',
  value_ranges_fresh_breeze: 'Brisa fresca',
  value_ranges_strong_breeze: 'Brisa forte',
  value_ranges_high_wind: 'Vento Forte',
  value_ranges_gale: 'Vendaval',
  value_ranges_severe_gale: 'Vendaval severo',
  value_ranges_storm: 'Tempestade',
  value_ranges_violent_storm: 'Tempestade Violenta',
  value_ranges_hurricane: 'Furacão',
  value_ranges_north_1: 'Norte',
  value_ranges_north_notheast: 'Norte-Nordeste',
  value_ranges_notheast: 'Nordeste',
  value_ranges_east_notheast: 'Leste-Nordeste',
  value_ranges_east: 'Leste',
  value_ranges_east_southeast: 'Leste-Sudeste',
  value_ranges_southeast: 'Sudeste',
  value_ranges_south_south_east: 'Sul-Sudeste',
  value_ranges_south: 'Sul',
  value_ranges_south_southwest: 'Sul-Sudoeste',
  value_ranges_southwest: 'Sudoeste',
  value_ranges_west_southwest: 'Oeste-Sudoeste',
  value_ranges_west: 'Oeste',
  value_ranges_west_northwest: 'Oeste-Noroeste',
  value_ranges_northwest: 'Nordeste',
  value_ranges_north_northwest: 'Norte-Noroeste',
  value_ranges_north_2: 'Norte',
  value_ranges_dry: 'Seco',
  value_ranges_normal: 'Normal',
  value_ranges_wet: 'Molhado',
  value_ranges_frost_point: 'Ponto de Geada',
  value_ranges_frost_point_danger: 'Geada perigosa',
  value_ranges_dew_point: 'Ponto de Orvalho',

  // Data Table Widget
  data_table_widget_header: 'Data',
  data_table_measurements: 'Medições',
  data_table_alarms: 'Alarmes',
  data_table_widget_from_date: 'Data Início',
  data_table_widget_to_date: 'Data Fim',
  data_table_date: 'Data',
  data_table_value: 'Valor',
  data_table_range: 'Faixa',
  flow: 'Fluxo',
  raw_readings: 'Dados Brutos',
  y_axis_include_zero: 'Incluir 0 no eixo Y',
  chart_options: 'Opções do gráfico',

  //sensors types
  rain_sensor: 'Sensor de Chuva',
  level_sensor: 'Sensor de Nivel',
  wind_speed_sensor: 'Sensor de Velocidade do Vento',
  wind_direction_sensor: 'Sensor de Direção do Vento',
  water_meter: 'Sensor de Medição de Água',
  pressure_sensor: 'Sensor de Pressão',
  humidity_sensor: 'Sensor de Humidade',
  temperature_sensor: 'Sensor de Temperatura',
  gas_flow_meter: 'Medidor de Vazão de Gás',
  heat_meter: 'Medidor de Calor',
  barometric_pressure_sensor: 'Sensor de Pressão Barometrica',
  soil_moisture_sensor: 'Sensor de Humidade de Solo',
  on_off_sensor: 'Chave Relé',
  generic_analog_sensor: '--',
  power_meter: 'Medidor de Energia',
  soil_temperature_sensor: 'Temperatura de Solo',
  dew_point_sensor: 'Ponto de Orvalho',
  particulate_matter_sensor: 'Partículas',
  geiger_mueller_counter: 'Radiação',
  soil_potential_sensor: 'Potencial do Solo',
  weight_sensor: 'Peso',

  sensor: {
    rain: {
      name: 'Sensor de Chuva',
      valueRanges: {
        no_rain: {
          abbrv: 'Sem Chuva ',
          description: 'Quando a taxa de precipitação for < 0.1 мм por hora',
        },
        light_rain: {
          abbrv: 'Chuva Fraca ',
          description: 'Quando a taxa de precipitação de estiver entre 0.1 and 2.5 mm por hora',
        },
        moderate_rain: {
          abbrv: 'Chuva Moderada ',
          description: 'Quando a taxa de precipitação de estiver entre 2.5 mm and 7.6 mm por hora',
        },
        heavy_rain: {
          abbrv: 'Chuva Forte ',
          description: 'Quando a taxa de precipitação de estiver entre 7.6 mm and 50 mm por hora',
        },
        violent_rain: {
          abbrv: 'Chuva Violenta ',
          description: 'Quando a taxa de precipitação for > 50 mm por hora',
        },
      },
    },
    windDirection: {
      name: 'Direção do Vento',
      valueRanges: {
        north_1: {
          abbrv: 'N',
          description: 'Norte (349° - 011°)',
        },
        north_2: {
          abbrv: 'N',
          description: 'Norte (349° - 011°)',
        },
        north_northeast: {
          abbrv: 'NNE',
          description: 'Norte-Nordeste (012°-033°)',
        },
        northeast: {
          abbrv: 'NE',
          description: 'Nordeste (034°-056°)',
        },
        east_northeast: {
          abbrv: 'LNE',
          description: 'Leste-Nordeste (102°-123°)',
        },
        east: {
          abbrv: 'L',
          description: 'Leste (079°-101°)',
        },
        east_southeast: {
          abbrv: 'LSE',
          description: 'Leste-Sudeste (102°-123°)',
        },
        southeast: {
          abbrv: 'SE',
          description: 'Sudeste (124°-146°)',
        },
        south_southeast: {
          abbrv: 'SSE',
          description: 'Sul-Sudeste (147°-168°)',
        },
        south_southwest: {
          abbrv: 'SSO',
          description: 'Sul-Sudoeste (192°-213°)',
        },
        south: {
          abbrv: 'S',
          description: 'Sul (169°-191°)',
        },
        southwest: {
          abbrv: 'SO',
          description: 'Sudoeste (214°-236°)',
        },
        west_southwest: {
          abbrv: 'OSO',
          description: 'Oeste-Sudoeste (237°-258°)',
        },
        west: {
          abbrv: 'O',
          description: 'Oeste (259°-281°)',
        },
        west_northwest: {
          abbrv: 'ONE',
          description: 'Oeste-Noroeste (282°-303°)',
        },
        northwest: {
          abbrv: 'NO',
          description: 'Noroeste (304°-326°)',
        },
        north_northwest: {
          abbrv: 'NNO',
          description: 'Norte-Noroeste (327°-348°)',
        },
      },
    },
    windSpeed: {
      name: 'Sensor de Velocidade do Vento',
      valueRanges: {
        no_wind: {
          abbrv: 'Sem Vento',
          description: '(0м/с - 0.1м/с)',
        },
        calm_wind: {
          abbrv: 'Vento Calmo',
          description: '(0.1m/s - 1m/s)',
        },
        light_air: {
          abbrv: 'Ar Fraco',
          description: ' (2m/s - 3m/s)',
        },
        light_breeze: {
          abbrv: 'Brisa Leve',
          description: ' (4m/s - 6m/s)',
        },
        gentle_breeze: {
          abbrv: 'Brisa Suave',
          description: ' (7m/s - 10m/s)',
        },
        moderate_breeze: {
          abbrv: 'Brisa Moderado',
          description: ' (11m/s - 16m/s)',
        },
        fresh_breeze: {
          abbrv: 'Brisa Fresca',
          description: '(17m/s - 21m/s)',
        },
        strong_breeze: {
          abbrv: 'Brisa Forte',
          description: ' (22m/s - 27m/s)',
        },
        high_wind: {
          abbrv: 'Vento Forte',
          description: ' (28m/s - 33m/s)',
        },
        gale: {
          abbrv: 'Vendaval',
          description: ' (34m/s - 40m/s)',
        },
        severe_gale: {
          abbrv: 'Vendaval Forte/Severo',
          description: ' (41m/s - 47m/s)',
        },
        storm: {
          abbrv: 'Tempestade',
          description: ' (48m/s - 55m/s)',
        },
        violent_storm: {
          abbrv: 'Tempestade Violenta',
          description: ' (56m/s - 63m/s)',
        },
        hurricane: {
          abbrv: 'Furacão',
          description: ' (64m/s - 77m/s)',
        },
      },
    },
    soil_temperature: {
      valueRanges: {
        idealMin: {
          abbrv: 'Subida lenta ',
          description: 'Subida lenta - temperatura é < 18.3°C',
        },
        idealMax: {
          abbrv: 'Condições Ideais',
          description: 'Máxima Ideal (Entre 18.4°C e 30°C)',
        },
        warm: {
          abbrv: 'Quente',
          description: 'Crescimento lento (Entre 30.1°C e 32.2°C)',
        },
        hot: {
          abbrv: 'Calor',
          description: 'Crescimento não eficiente (Entre 32.3°C e 45°C)',
        },
        dangerous: {
          abbrv: 'Perigoso',
          description: 'Morte de Bacteria, Perda de humidade( > 45.1°C)',
        },
      },
    },
    soilmoisture: {
      valueRanges: {
        dry: {
          abbrv: 'Seco',
          description: 'Humidade do solo perigosamente baixa ( < 80%)',
        },
        normal: {
          abbrv: 'Irrigar',
          description: 'Irrigação a ser aplicada (Entre 80% e 90%)',
        },
        wet: {
          abbrv: 'Molhado',
          description: 'Nehuma irrigação é nescessária ( Entre 90% e 100%)',
        },
      },
    },
    dew_point_sensor: {
      valueRanges: {
        frost_point: {
          abbrv: 'Geada',
          description: 'Ponto de Geada abaixo de 1 C.',
        },
        frost_point_danger: {
          abbrv: 'Perigo de Geada',
          description: 'Ponto de Geada abaixo de 5 C.',
        },
        dew_point: {
          abbrv: 'Ponto de orvalho',
          description: 'Ponto de orvalho acima de 5 C.',
        },
      },
    },
    gammaRadiation: {
      valueRanges: {
        normal: {
          abbrv: 'Normal',
        },
        abnormal: {
          abbrv: 'Alto',
        },
        dangerous: {
          abbrv: 'Alta perigosidade',
        },
      },
    },
    moisture: {
      valueRanges: {
        dry: {
          abbrv: 'Seco',
        },
        normal: {
          abbrv: 'Normal',
        },
        wet: {
          abbrv: 'Molhado',
        },
      },
    },
    temperature: {
      valueRanges: {
        cool: {
          abbrv: 'Frio',
        },
        ideal: {
          abbrv: 'Ideal',
        },
        warm: {
          abbrv: 'Quente',
        },
        hot: {
          abbrv: 'Calor',
        },
        dangerous: {
          abbrv: 'Calor Perigoso',
        },
      },
    },
    airMicroGrams: {
      valueRanges: {
        good: {
          abbrv: 'Baixo',
        },
        moderate: {
          abbrv: 'Moderado',
        },
        minimal: {
          abbrv: 'Mínima',
        },
        sensitive: {
          abbrv: 'Sensitivo',
        },
        discomfort: {
          abbrv: 'Desconforto',
        },
        unhealthy: {
          abbrv: 'Insalubre',
        },
        veryUnhealthy: {
          abbrv: 'Muito Insalubre',
        },
        hazardous: {
          abbrv: 'Perigoso',
        },
        respiratoryIllness: {
          abbrv: 'Perigoso (Doença Respiratória)',
        },
        healthImpact: {
          abbrv: 'Perigoso para Saúde',
        },
      },
    },
    barometricPressure: {
      valueRanges: {
        low: {
          abbrv: 'Baixo',
          description: 'Pressão Barometrica menos que 850.',
        },
        normal: {
          abbrv: 'Normal',
          description: 'Pressão Barometrica maior que 850 e abaixo de 1500',
        },
        high: {
          abbrv: 'Alto',
          description: 'Pressão Barometrica maior que 1500 e abaixo de 3000',
        },
      },
    },
    load_cells: {
      valueRanges: {
        low: {
          abbrv: 'Normal',
          description: 'Carga abaixo de 999 kN.',
        },
        normal: {
          abbrv: 'Warning',
          description: 'Carga entre 1000 e 1100 kN',
        },
        high: {
          abbrv: 'Alarme',
          description: 'Carga acima de 1100 kN',
        },
      },
    },
  },

  //GEOMAN MAP LIBRARY CUSTOM TRANSLATE
  // --tooltips--
  placeMarker: 'Clique para marcar',
  firstVertex: 'Clique para inserir o primeiro vértice',
  continueLine: 'Clique para continuar o desenho',
  finishLine: 'Clique em qualquer marcador para finalizar',
  finishPoly: 'Clique no primeiro marcador para finalisar',
  finishRect: 'Clique para finalisar',
  startCircle: 'Clique para inserir o centro do círculo',
  finishCircle: 'Clique para finalizar o círculo',
  placeCircleMarker: 'Clique para inserir um círculo',
  placeText: 'Clique para inserir um texto',

  // -- actions --
  finish: 'Terminar',
  cancel: 'Cancelar',
  removeLastVertex: 'Remove o último Vértice',

  // -- button titles --
  drawMarkerButton: 'Desenhar Marcador',
  drawPolyButton: 'Desenhar Poligonos',
  drawLineButton: 'Desenhar Polilinhas',
  drawCircleButton: 'Desenhar Círculos',
  drawRectButton: 'Desenhar Retangulos',
  editButton: 'Editar Camadas',
  dragButton: 'Arrastar Camadas',
  cutButton: 'Cortar Camadas',
  deleteButton: 'Excluir Camadas',
  drawCircleMarkerButton: 'Desenhar Marcador de Círculos',
  snappingButton: 'Ajustar marcador arrastado para outras camadas e vértices',
  pinningButton: 'Fixar vértices compartilhados juntos',
  rotateButton: 'Rotacionar Camadas',
  drawTextButton: 'Desenhar texto',

  //CONFIRMATION DIALOG WINDOW
  confirmMessage: 'Você tem certeza que deseja apagar estes (poligonos ou area)?',
  confirmAgreeButton: 'Confirma',
  confirmDisagreeButton: 'Não Confirma',

  //Journal
  journal_page_header: 'Jornal',

  //Calendar"
  calendar_page_header: 'Calendário',

  //Period-Selector options
  period_label: 'Período',
  route_date_selector: 'Data da Rota',

  period_date_range_option: 'Intervalo de Datas',
  period_custom_option: 'Customizado',
  period_today_option: 'Hoje',
  period_week_option: 'Semana',
  period_month_option: 'Mes',
  period_last_h_option: 'Última Hora',
  period_last_2_h_option: 'Últimas 2 houras',
  period_last_4_h_option: 'Últimas 4 houras',
  period_last_24_h_option: 'Últimas 24 houras',
  period_last_48_h_option: 'Últimas 48 houras',

  //YAMBOL HEADER
  municipality_yambol: 'Município de Yambol',

  //Devices List
  search_placeholder: 'Procura Nome do dispositivo',

  //Error-handling
  toast_server_error_message: 'Um erro ocorreu com uma das requisiçoes para o servidor',
  toast_alarms_error_message: 'Falhou na recuperação dos alarmes',
  toast_map_error_message: 'Falhor para recuperação do mapa',
  toast_dashboard_error_message: 'Falhou na recuperação do Painel de Controle',
  toast_devices_error_message: 'Falhou na recuperação dos dispositivos',
  toast_device_config_error_message: 'Falhou na Recuperação para o dispositivo: {{deviceNumber}}',
  toast_device_current_values_error_message:
    'Falhou na Recuperação valor atual para: {{deviceNumber}}',
  toast_devices_location_error_message: 'Falhou na Recuperação na localização do dispositivo',
  toast_map_setting_per_name_error_message:
    'Falhou na Recuperação de Configuração de mapa do mapa atual',
  toast_map_settings_error_message: 'Falhou na Recuperação de configuração de todos os mapas',
  toast_get_user_error_message: 'Falhou na Recuperação do seu usuário',
  toast_set_user_language_error_message: 'Falhou na escolha do idioma',

  //CurrentValuesBox
  current_values_box_info_description: 'Sem Informação',
  current_values_box_reference_values: 'Valores de Referência',
  device_info_panel_loading_values: 'Carregando valores atuais',
  device_info_panel_no_values: 'Nenhum valor atual disponível',
  device_info_panel_values_error: 'Não foi possível carregar os valores atuais',

  // Buttons and dropdowns
  alarms_export_header: 'Alarmes',
  alarms_export_header_with_device: `Alarmes: {{device_number}}`,
  alarms_export_search: 'Procura',
  alarms_export_download: 'Download',
  alarms_export_format: 'Formatar',

  // Table columns
  alarms_export_table_date: 'Data',
  alarms_export_table_device_number: 'Número do dispositivo',
  alarms_export_table_device_name: 'Nome do dispositivo',
  alarms_export_table_sensor_index: 'Índice do sensor',
  alarms_export_table_sensor_name: 'Nome do sensor',
  alarms_export_table_alarm_type: 'Tipo',
  alarm_type_on_off_alarm: 'Alarme liga/desliga',
  alarm_type_no_zero_consumption: 'Sem consumo zero',
  alarm_type_all_zero_consumption: 'Consumo zero',
  alarm_type_low_flow: 'Vazão baixa',
  alarm_type_high_flow: 'Vazão alta',
  alarm_type_high_consumption: 'Consumo alto',
  alarm_type_missed_transmission: 'Transmissão perdida',
  alarm_type_device_removed: 'Dispositivo removido',
  alarm_type_low_level: 'Nível baixo',
  alarm_type_high_level: 'Nível alto',
  alarm_type_tamper: 'Violação',
  alarm_type_oversized: 'Superdimensionado',
  alarm_type_undersized: 'Subdimensionado',
  alarm_type_low_battery: 'Bateria fraca',
  alarm_type_blockage: 'Bloqueio',
  alarm_type_burst: 'Ruptura',
  alarm_type_reverse_flow: 'Vazão reversa',
  alarm_type_range_event: 'Evento de faixa',
  alarm_type_very_low_level: 'Nível muito baixo',
  alarm_type_very_high_level: 'Nível muito alto',
  alarm_type_leakage: 'Vazamento',
  alarm_type_low_temperature: 'Temperatura baixa',
  alarm_type_no_consumption: 'Sem consumo',
  alarm_type_negative_flow: 'Vazão negativa',
  alarm_type_empty_spool: 'Tubulação vazia',
  alarm_type_combination_of_alarms: 'Combinação de alarmes',
  alarm_type_standstill: 'Parado',
  alarm_type_reset_error: 'Erro de reinicialização',
  alarm_type_rf_error: 'Erro de RF',
  alarm_type_cs_error: 'Erro de CS',
  alarm_type_measuring_error: 'Erro de medição',
  alarm_type_reset_event: 'Reinicialização',
  alarm_type_magnetic_field: 'Campo magnético',
  alarm_type_sensor_fraud: 'Fraude no sensor',
  alarms_export_table_severity: 'Gravidade',
  alarm_severity_tooltip: 'Gravidade: {{value}} de 10',
  alarm_severity_none_tooltip: 'Nenhuma gravidade informada para este alarme',
  alarms_export_table_alarm_status: 'Status',
  alarms_export_table_description: 'Descrição',
  alarms_export_chip_status_active: 'Ativo',
  alarms_export_chip_status_inactive: 'Inativo',
  alarms_export_switch_title_label: 'Atualização Automática',
  alarms_export_error_alert_message: 'Um erro ocorreu ao gerar a data.',
  alarms_export_error_too_big_query:
    'Recuperar o histórico do superadministrador para todos os dispositivos é uma solicitação muito grande. Selecione uma empresa.',

  /*
   * |=================|
   * | Task Scheduler  |
   * |=================|
   */

  task_scheduler_link_label: 'Agenda',
  task_scheduler_go_back_btn_label: 'Voltar',

  // Table columns
  task_scheduler_table_device_number: 'Número do Dispositivo',
  task_scheduler_table_device_name: 'Nome do Dispositivo',
  task_scheduler_list_header: 'Tarefas Atuais',

  task_scheduler_title: 'Agendador de Tarefas',
  task_scheduler_remove: 'Excluir',
  task_scheduler_remove_confirmation: 'Você tem certeza que deseja Excluir estas tarefas?',
  task_scheduler_confirm: 'Confirmar',
  task_scheduler_cancel: 'Cancelar',
  task_scheduler_remove_active: 'Tarefas ativa não pode ser removida',
  task_scheduler_action_not_reversible: 'Esta ação não é reversível.',
  task_scheduler_edit: 'Editar',

  // Form
  task_scheduler_add_form_header: 'Criar Tarefa',
  task_scheduler_edit_form_header: 'Editar tarefa: {{taskName}}',
  task_scheduler_form_name: 'Nome da tarefa',
  task_scheduler_form_from_date: 'Data Início',
  task_scheduler_form_to_date: 'Data Fim',
  task_scheduler_form_repeat: 'Repete',
  task_scheduler_form_period: 'Periodo',
  task_scheduler_form_temporal: 'Temporal',
  task_scheduler_form_temporal_days: 'Diário',
  task_scheduler_form_execution_hour: 'Hora de Execução',
  task_scheduler_form_execution_minute: 'Minutos de Execução',
  task_scheduler_form_command: 'comando',

  task_scheduler_form_error_name: 'Nome da Tarefa é necessário',
  task_scheduler_form_error_period: 'Periodo é necessário',
  task_scheduler_form_error_temporal: 'Temporal é nescessário',
  task_scheduler_form_error_execution_hour: 'Horas de Execução é nescessário',
  task_scheduler_form_error_execution_minute: 'Minutos de Execução é nescessário',
  task_scheduler_form_error_command: 'Comando é nescessário',

  // Toast messages
  task_scheduler_form_create_message: 'Tarefa criada com sucesso',
  task_scheduler_form_update_message: 'Tarefa editada com sucesso',
  task_scheduler_form_create_error_message: 'Um erro ocorreu na criação da tarefa',
  task_scheduler_form_update_error_message: 'Um erro ocorreu na edição da tarefa',
  task_scheduler_form_delete_message: 'Tarefa removida com sucesso',

  // Task execution
  task_execution_error_loading_message: 'Não foi possível carregar as execuções de tarefas',

  // Tasks list
  scheduled_tasks_list_event_name: 'Nome do Evento',
  scheduled_tasks_list_start_date: 'Data Início',
  scheduled_tasks_list_end_date: 'Data Final',
  scheduled_tasks_list_execution_time: 'Tempo de Execução',
  scheduled_tasks_list_last_execution: 'Última execução',
  scheduled_tasks_list_is_active: 'Está Ativo',
  scheduled_tasks_event_logs_btn_text: 'Logs de Eventos',
  scheduled_tasks_view_btn_text: 'Visualizar',

  // History table
  scheduled_event_history_title: 'Histórico de Tarefas',
  scheduled_tasks_history_date_of_execution_header: 'Data da execução',
  scheduled_tasks_history_task_name_header: 'Nome da tarefa',
  scheduled_tasks_history_status_header: 'Status da execução',
  scheduled_tasks_history_overview_btn_text: 'Visão geral',
  scheduled_tasks_history_task_status_done: 'Feito',
  scheduled_tasks_history_task_status_pending: 'Pendente',
  scheduled_tasks_history_task_status_failed: 'Falhou',
  scheduled_tasks_history_task_status_done_with_errors: 'Feito com erros',

  // Task Overview
  task_scheduler_command_task_overview: 'Visão geral da tarefa',
  task_overview_scheduled_event_name: 'Nome do evento agendado',
  task_overview_desired_state: 'Estado desejado',
  task_overview_command_state: 'Estado do comando',

  // Event Form
  scheduled_task_event_form_required_state: 'Estado desejado',
  scheduled_task_event_form_required_states: 'Estados desejados',
  scheduled_task_event_form_scheduled_event: 'Evento agendado',
  scheduled_task_event_form_new_scheduled_event: 'Novo evento agendado',
  scheduled_task_event_form_edit_scheduled_event: 'Editar evento agendado',
  scheduled_task_event_form_event_type: 'Tipo de evento',
  scheduled_task_event_form_start_date: 'Data Início',
  scheduled_task_event_form_end_date: 'Data Final',
  scheduled_task_event_form_last_execution: 'Última execução',
  scheduled_task_event_form_execution_time: 'Tempo de execução',
  scheduled_task_event_form_relay_state: 'Estado do Relé',
  scheduled_task_event_form_select: 'Selecionar',
  scheduled_task_event_form_hour: 'Hora de execução do dispositivo',
  scheduled_task_event_form_minute: 'Minuto de execução do dispositivo',
  scheduled_task_event_form_modbus_command_type: 'Tipo de comando',
  scheduled_task_event_form_modbus_command_type_read_coil_1: 'Obter estado do relé',
  scheduled_task_event_form_modbus_command_type_read_register_3: 'Obter leitura',
  scheduled_task_event_form_modbus_command_type_write_coil_5: 'Enviar comando',

  // Scheduled task event types
  command_type_single_relay_switch: 'Interruptor de Relé Único',
  command_type_relay_switch: 'Interruptor de Relé',
  command_type_auto_relay_switch: 'Interruptor de Relé Automático',
  command_type_send_date_over_mqtt: 'Enviar Data pelo MQTT',
  command_type_modbus: 'Modbus',
  command_type_tasmota_power: 'Potência Tasmota',
  command_type_scheduled_relay_command: 'Relé agendado',
  command_type_scheduled_relay_command_4: 'Comandos de Relé Agendados (4)',
  command: 'Comando',

  // Error handling
  scheduled_tasks_could_not_find_event_with_id: `Não foi possível encontar o evento agendado com o id: {{event_id}}`,
  scheduled_tasks_could_not_get_event_logs_for_event: 'Falhou na recuperção do logs para o evento',
  scheduled_tasks_could_not_update_event_with_id:
    'Não foi possível atualizar o evento agendado com o id: {{event_id}}',
  logo_error_message: 'Não foi possível carregar o logotipo da empresa',

  //resolvers
  scheduled_tasks_event_name_min_length: 'O nome do evento deve ter pelo menos 3 caracteres',
  scheduled_tasks_event_name_max_length: 'O nome do evento deve ter menos de 50 caracteres',
  scheduled_tasks_from_date_invalid: 'A data de início deve ser posterior a hoje',
  scheduled_tasks_to_date_invalid: 'A data final deve ser posterior à data de início',
  scheduled_tasks_execution_hour_range: 'A hora de execução deve estar entre 0 e 23',
  scheduled_tasks_execution_minute_range: 'O minuto de execução deve estar entre 0 e 59',
  scheduled_tasks_period_required: 'O período deve ser um número inteiro positivo',
  scheduled_tasks_temporal_required: 'O valor temporal é obrigatório',
  scheduled_tasks_event_device_numbers_length:
    'Cada número de dispositivo deve ter exatamente 8 caracteres',
  scheduled_tasks_event_sensor_index_range:
    'O índice do sensor deve ser um número inteiro positivo ou 0',
  scheduled_tasks_event_relay_states_required:
    'Os estados do relé devem ser especificados para o tipo RELAY_SWITCH',
  scheduled_tasks_event_required_state_auto_relay:
    'O estado requerido deve ser especificado para o tipo AUTO_RELAY_SWITCH',
  scheduled_tasks_event_required_state_tasmota_power:
    'O estado requerido deve ser especificado para o tipo TASMOTA_POWER',
  scheduled_tasks_event_slave_device_number_length:
    'O número do dispositivo escravo deve ter exatamente 8 caracteres',
  scheduled_tasks_event_type_invalid: 'Tipo de evento inválido selecionado',
  scheduled_tasks_device_number_is_required: 'Selecione o(s) dispositivo(s) para criar um evento',

  /*
   * |=====================|
   * | License Error Page  |
   * |=====================|
   */
  license_error_page_access_restricted: 'Acesso Restrito',
  license_warning_access_hold: 'Acesso à conta suspenso',
  license_warning_access_hold_description:
    'Seu acesso à plataforma foi temporariamente suspenso devido a um pagamento pendente. Incentivamos você a entrar em contato com nosso suporte ou com seu representante designado para resolver este problema.',
  license_warning_no_valid_license: 'Licença inválida',
  license_warning_no_valid_license_description:
    'Não conseguimos encontrar uma licença válida associada a esta conta. Entre em contato com seu representante designado ou com nosso suporte para obter assistência.',
  license_warning_devices_count_limit_reached: 'Número máximo de dispositivos atingido',
  license_warning_devices_count_limit_reached_description:
    'Você atingiu o número máximo de dispositivos que pode vincular à conta com a licença. Para adicionar mais dispositivos, entre em contato com seu representante designado ou com nosso suporte.',
  license_warning_generic_title: 'Sem licença',
  license_warning_generic_description: 'Não é possível continuar devido a problemas com a licença.',
  error_forbidden_operation_not_allowed: 'Não permitido',

  /*
   * |=================|
   * | Trashbags       |
   * |=================|
   */
  trashbags_page_header: 'Sacos de Resíduos',
  trashbags_status_new: 'Novo',
  trashbags_status_in_progress: 'Em Andamento',
  trashbags_status_closed: 'Fechado',
  trashbags_fetch_error: 'Erro ao buscar lotes',
  trashbags_batch_details_error: 'Erro ao buscar detalhes do lote',
  trashbags_batch_number: 'Rolo de Sacos',
  trashbags_batch_id: 'ID do Rolo',
  trashbags_total_count: 'Total',
  trashbags_new: 'Novo',
  trashbags_in_progress: 'Em Andamento',
  trashbags_closed: 'Fechado',
  trashbags_id: 'ID',
  trashbags_rfid: 'RFID',
  trashbags_status: 'Status',
  trashbags_account_number: 'Número do Lote',
  trashbags_created_date: 'Data de Criação',
  trashbags_collection_date: 'Data de Coleta',
  trashbags_more_info_tooltip: 'Clique para ver mais informações',
  trashbags_details_title: 'Detalhes do Saco',
  trashbags_type: 'Tipo',
  trashbags_location: 'Localização',
  trashbags_open_in_maps: 'Abrir no Google Maps',
  trashbags_empty_title: 'Nenhum rolo de sacos encontrado',
  trashbags_empty_description: 'Ainda nao ha rolos de sacos para exibir.',
  trashbags_batch_empty_title: 'Nenhum saco neste rolo',
  trashbags_batch_empty_description: 'Este rolo ainda nao contem sacos.',

  /*
   * |=================|
   * | Collections     |
   * |=================|
   */
  collections_page_header: 'Relatório de Coleta de Lixo',
  collections_fetch_error: 'Erro ao buscar dados de coleta',
  collections_from_date: 'Data Início',
  collections_to_date: 'Data Fim',
  collections_account_number: 'Número do Lote',
  collections_account_id: 'ID da Conta',
  collections_count: 'Quantidade de Coletas',
  collections_volume: 'Volume de Coleta',
  collections_export_csv: 'Exportar',
  collections_no_data_to_export: 'Sem dados para exportar',

  /*
   * |====================|
   * | Truck Collections  |
   * |====================|
   */
  truck_collections_page_header: 'Relatório de Coletas por Caminhão',
  truck_collections_fetch_error: 'Erro ao buscar dados de coleta por caminhão',
  truck_collections_from_date: 'Data Início',
  truck_collections_to_date: 'Data Fim',
  truck_collections_truck_name: 'Nome do Caminhão',
  truck_collections_count: 'Quantidade de Coletas',
  truck_collections_volume: 'Volume de Coleta',
  truck_collections_export_csv: 'Exportar CSV',
  truck_collections_view_on_map: 'Ver no mapa',
  truck_collections_no_data_to_export: 'Sem dados para exportar',

  /*
   * |================================|
   * | Truck Collections by Container |
   * |================================|
   */
  truck_collections_by_container_page_header: 'Relatório de Coletas por Caminhão por Contêiner',
  truck_collections_by_container_fetch_error: 'Erro ao buscar coletas por contêiner',
  truck_collections_by_container_from_date: 'Data Início',
  truck_collections_by_container_to_date: 'Data Fim',
  truck_collections_by_container_truck_number: 'Nome do Caminhão',
  truck_collections_by_container_container_number: 'Número do Contêiner',
  truck_collections_by_container_container_address: 'Endereço do Contêiner',
  truck_collections_by_container_location: 'Localização',
  truck_collections_by_container_status: 'Status',
  truck_collections_by_container_date: 'Data',
  truck_collections_by_container_status_correct: 'Localização Correta',
  truck_collections_by_container_status_incorrect: 'Localização Incorreta',
  truck_collections_by_container_open_in_maps: 'Abrir no Google Maps',
  truck_collections_by_container_export_csv: 'Exportar CSV',
  truck_collections_by_container_view_on_map: 'Ver no mapa',
  truck_collections_by_container_no_data_to_export: 'Sem dados para exportar',

  /*
   * |=======================|
   * | Container Collections |
   * |=======================|
   */
  container_collections_page_header: 'Relatório de Coletas por Contêiner',
  container_collections_fetch_error: 'Erro ao buscar coletas por contêiner',
  container_collections_from_date: 'Data Início',
  container_collections_to_date: 'Data Fim',
  container_collections_container_number: 'Número do Contêiner',
  container_collections_container_address: 'Endereço do Contêiner',
  container_collections_account_id: 'ID da Conta',
  container_collections_account_number: 'Número da Conta',
  container_collections_count: 'Quantidade de Coletas',
  container_collections_volume: 'Volume de Coleta',
  container_collections_export_csv: 'Exportar CSV',
  container_collections_no_data_to_export: 'Sem dados para exportar',

  // Common
  close_btn: 'Fechar',

  // TanstackTable UI
  table_search_placeholder: 'Pesquisar…',
  table_columns: 'Colunas',
  table_toggle_all: 'Alternar todas',
  table_filter: 'Filtrar',
  table_clear_filter: 'Limpar filtro',
  table_pin_left: 'Fixar à esquerda',
  table_pin_right: 'Fixar à direita',
  table_unpin: 'Desafixar',
  table_group_by_column: 'Agrupar por esta coluna',
  table_ungroup: 'Desagrupar',
  table_filter_all: 'Todos',
  table_no_values: 'Sem valores',
  table_min: 'Mín',
  table_max: 'Máx',
  table_equals: 'Igual a',
  table_from: 'De',
  table_to: 'Até',
  table_yes: 'Sim',
  table_no: 'Não',
  table_filter_placeholder: 'Filtrar…',
  table_density_compact: 'Compacto',
  table_density_standard: 'Padrão',
  table_density_comfortable: 'Confortável',
  table_auto_page_size: 'Automático ({rows})',
};

module.exports = ptBr;
